import { render, staticRenderFns } from "./MemberProfileDialog.vue?vue&type=template&id=e07e2bb4&scoped=true"
import script from "./MemberProfileDialog.vue?vue&type=script&lang=js"
export * from "./MemberProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./MemberProfileDialog.vue?vue&type=style&index=0&id=e07e2bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07e2bb4",
  null
  
)

export default component.exports